import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  IconColor,
  IconFill,
  IconImage,
  IconSize,
} from '@interfaces/common.interface';
import { iconRegistry } from '@constants/icons';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  _icon: IconImage = 'default';
  @Input() set icon(icon: IconImage) {
    this._icon = icon;
    setTimeout(() => {
      this.iconPath = this.fetchIcon(this.icon);
      this.cdr.detectChanges();
    });
  }

  get icon(): IconImage {
    return this._icon;
  }

  @Input() size: IconSize = 'large';
  @Input() color: IconColor = 'dark';
  @Input() classess!: string;
  @Input() colorFill: IconColor = 'none';
  @Input() circle: IconFill = 'none';
  @Input() staticStroke = false;
  @Input() strokeWidth = '2';

  iconPath = '';

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.icon) {
      this.iconPath = this.fetchIcon(this.icon);
    }
  }

  fetchIcon(id: IconImage): string {
    const icon = iconRegistry.find((el) => el.id === id);
    if (icon) {
      return `/assets/icons/${environment.theme}/${icon.category}/${icon.id}.svg`;
    } else {
      return '';
    }
  }
}
